"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

import { AppErrorDigest, AppErrorPanel } from "@/components/app-error-panel";
import { RadiumLogo } from "@/components/brand/radium-logo";
import { radiumMonoFont, radiumWordmarkFont } from "@/lib/fonts";

import "./globals.css";

export default function GlobalErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        className={`${radiumMonoFont.variable} ${radiumWordmarkFont.variable} min-h-screen bg-background text-foreground antialiased`}
      >
        <div className="relative flex min-h-screen flex-col bg-background">
          <header className="flex shrink-0 items-center justify-between px-6 py-5 lg:px-10">
            <a href="/" className="flex w-fit shrink-0 items-center">
              <RadiumLogo variant="wordmark" className="h-12 w-auto" />
            </a>
          </header>

          <main className="mx-auto flex min-h-0 w-full flex-1 flex-col items-center justify-center px-6 pb-16 lg:px-10">
            <AppErrorPanel variant="page" onRetry={reset} />
          </main>

          {error.digest ? <AppErrorDigest digest={error.digest} className="pb-6 text-center" /> : null}
        </div>
      </body>
    </html>
  );
}
